export default __webpack_public_path__ + "static/media/launch.91429fb5.svg";